import React from 'react';

const AboutMe = () => {
    function calculateYearsAndMonths(startDate) {
        const start = new Date(startDate);
        const end = new Date(Date.now());

        let years = end.getFullYear() - start.getFullYear();
        let months = end.getMonth() - start.getMonth();

        if (months < 0) {
            years--;
            months += 12;
        }

        const yearText = years === 1 ? '1 year' : `${years} years`;
        const monthText = months === 1 ? '1 month' : `${months} months`;

        return `${yearText} ${monthText}`;
    }


    const startDate = "1999-12-31";
const jobStart = "2022-10-01";

    const difference = calculateYearsAndMonths(startDate);
const jobDiff = calculateYearsAndMonths(jobStart);
    return (
        <>
            <h2><span className='text-blue-500'>A</span>bout Me</h2>
            <hr />
            <div className="flex flex-col md:flex-row py-2">
                <div className="flex-1  ">
                    <p className='text-justify'> Hello! I’m Saiful Islam Shanto. I'm a software developer specializing in web development, crafting efficient and scalable applications with a focus on clean code and user-friendly interfaces. Passionate about continuous learning and problem-solving, I thrive in dynamic environments where I can contribute to building innovative digital solutions.
                    </p>
                </div>
                <div className="hidden lg:block w-px h-32 bg-gray-300 mx-4"></div>
                <div className="flex-1  p-2 relative overflow-x-auto">
                    <table className="w-full text-sm dark ">
                        <tbody>
                            <tr >
                                <td className=" text-left py-2  font-medium text-gray-900 whitespace-nowrap ">
                                    <span className='p-1 rounded bg-blue-300'>Age: </span>
                                </td>
                                <td className=" text-right">
                                    {difference}
                                </td>
                            </tr>
                            <tr >
                                <td className=" text-left py-2  font-medium text-gray-900 whitespace-nowrap ">
                                    <span className='p-1 rounded bg-blue-300'> Resident: </span>
                                </td>
                                <td className=" text-right">
                                    Bangladesh
                                </td>
                            </tr>
                            <tr >
                                <td className=" text-left  py-2 font-medium text-gray-900 whitespace-nowrap ">
                                    <span className='p-1 rounded bg-blue-300'> Address:</span>
                                </td>
                                <td className=" text-right">
                                    Kazipara, Mirpur, Dhaka-1216
                                </td>
                            </tr>
                            <tr >
                                <td className=" text-left  py-2 font-medium text-gray-900 whitespace-nowrap ">
                                    <span className='p-1 rounded bg-blue-300'> Experience:</span>
                                </td>
                                <td className=" text-right">
                                    {jobDiff}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default AboutMe;